import type { PurchaseOrder } from '../types/purchase/purchaseOrder';

export const purchaseOrderRowKey = (po: PurchaseOrder): string => String(po.id);

export interface PurchaseOrderTotals {
  count: number;
  totalAmount: number;
  balance: number;
}

export const computePurchaseOrderTotals = (rows: PurchaseOrder[]): PurchaseOrderTotals => {
  let totalAmount = 0;
  for (const row of rows) {
    totalAmount += parseFloat(row.total_amount) || 0;
  }
  return {
    count: rows.length,
    totalAmount,
    balance: 0,
  };
};
